import {Directive, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';

// @ts-ignore
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[selectorValue]',
})
export class SelectorValueDirective {
  isReadonly = false;
  constructor() {}

  @Input() selectorValue: object;
  @Input() caption: string;
  @Input() set readonly(value) {
    this.isReadonly = true;
  }

  @HostBinding('class') classes = 'proposed-value';

  @Output() selected = new EventEmitter();

  @HostListener('click') click() {
    this.selected.emit();
  }
}
